import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    QuestionnaireItemDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        minWidth: 0
    },
    body: {
        flexDirection: "column",
        minWidth: 0
    }
});

export const useStyles = ({
    spaces
}: QuestionnaireItemDynamicStyleType) => {
    const styles = {
        body: {
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
